if (!customElements.get('adev-product-media')) {
    customElements.define('adev-product-media', class adevProductMedia extends HTMLElement {
        constructor() {
            super();
        }

        initCarousel(){
            const mainEl = this.querySelector('[data-adev-product-media="main"]');
            this.mainCarousel = new Flickity(mainEl, {
                cellAlign: 'left',
                contain: true,
                wrapAround: true,
                prevNextButtons: false,
                pageDots: true
            });

            const prevEl = this.querySelector('[data-adev-product-media="main-prev"]');
            const nextEl = this.querySelector('[data-adev-product-media="main-next"]');
            if (prevEl && nextEl) {

                prevEl.addEventListener('click', () => {
                    this.mainCarousel.previous();
                });

                nextEl.addEventListener('click', () => {
                    this.mainCarousel.next();
                });
            }

            const thumbsEl = this.querySelector('[data-adev-product-media="thumbnails"]');
            if (thumbsEl) {
                this.thumbsCarousel = new Flickity(thumbsEl, {
                    cellAlign: 'left',
                    contain: true,
                    wrapAround: true,
                    prevNextButtons: false,
                    pageDots: false,
                    asNavFor: '[data-adev-product-media="main"]'
                });
            }
        }

        destroyCarousel() {
            if (this.mainCarousel) {
                this.mainCarousel.destroy();
                this.mainCarousel = null;
            }
            if (this.thumbsCarousel) {
                this.thumbsCarousel.destroy();
                this.thumbsCarousel = null;
            }
        }

        connectedCallback() {
            this.initCarousel();
        }

        disconnectedCallback() {
            this.destroyCarousel();
        }

    });
}